import { Component } from 'react';
import PropTypes from 'prop-types';
import CardHighlight from "./CardHighlight";

import faceImage from '../assets/face.png';

class Card extends Component {

  render() {
    const ratio = this.props.width / 550;

    const prefix = (process.env.NODE_ENV === 'production') ? '/assets/t-meishi-project.com/designer/omakase' : '';

    return (
      <div className="t-card" style={{ width: this.props.width + 'px' }}>
        <img src={prefix + faceImage} alt="Face" className="t-card-image" />
        <span className="t-card-image-overlay">お客様の顔が入ります</span>
        {this.props.objects.map((object, i) => {
          // const text = (object.id in this.props.values) ? this.props.values[object.id] : object.sample;

          const fontSize = (object.id in this.props.fontSizes) ? this.props.fontSizes[object.id] : object.fontSize;

          const styles = {
            left: (object.x * 100) + '%',
            top: (object.y * 100)  + '%',
            fontSize: (fontSize * ratio) + 'px'
          };

          if (this.props.sample) {
            return (
              <span key={i} className={"t-card-object t-card-object-" + object.id} style={styles}>{object.sample}</span>
            );
          }

          const text = (object.id in this.props.values) && this.props.values[object.id];

          if (text) {
            return (
              <span key={i} className={"t-card-object t-card-object-" + object.id} style={styles}>{text}</span>
            );
          } else if (this.props.showPlaceholder) {
            return (
              <span key={i} className={"text-muted t-card-object t-card-object-" + object.id} style={styles}>{object.sample}</span>
            );
          }


        })}
        {(typeof this.props.selectedIndex !== 'undefined') && (
          <CardHighlight selector={".t-card-object-" + this.props.objects[this.props.selectedIndex].id} />
        )}
      </div>
    );
  }
}

Card.propTypes = {
  image: PropTypes.string,
  imageStyle: PropTypes.object,
  objects: PropTypes.array.isRequired,
  values: PropTypes.object,
  selectedIndex: PropTypes.number,
  width: PropTypes.number,
  showPlaceholder: PropTypes.bool,
  fontSizes: PropTypes.object,
  sample: PropTypes.bool
};

Card.defaultProps = {
  values: {},
  fontSizes: {},
  showPlaceholder: true,
  sample: false
};

export default Card;